var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"gui-pdf-preview",attrs:{"src":`${_vm.pdfjsUrl}?file=${_vm.baseService}/basiceg/v1/bytes/${_vm.pdfFileUrl}&w=${_vm.warterMark}`,"frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }